export default __webpack_public_path__ + "5e00236085deb3fdc2ce6b21762a1e4d.svg";